import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export function useAviator() {
  const [s, setS] = useState(null);
  const [m, setM] = useState(1);
  const [now, setNow] = useState(0);
  const offset = useRef(0);

  const poll = async () => {
    try {
      const { data } = await api.get("/aviator/state");
      offset.current = data.server_time * 1000 - Date.now();
      setS(data);
    } catch { /* retry next tick */ }
  };

  useEffect(() => {
    poll();
    const iv = setInterval(poll, 500);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    let raf;
    const tick = () => {
      const t = (Date.now() + offset.current) / 1000;
      setNow(t);
      if (s?.phase === "flying") setM(Math.max(1, Math.floor(Math.exp(s.growth * (t - s.start_at)) * 100) / 100));
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [s]);

  return { s, m: s?.phase === "crashed" ? s.crash : m, now, poll };
}
